import {
  ApiBlueprint,
  createFrontendPlugin,
  discoveryApiRef,
  fetchApiRef,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';
import { mcpChatApiRef } from './api';
import { McpChat } from './api/McpChatApi';
import { BotIconComponent } from './assets/Icons';
import { rootRouteRef } from './routes';

/**
 * MCP Chat Api
 * @public
 */
const mcpChatApi = ApiBlueprint.make({
  params: defineParams =>
    defineParams({
      api: mcpChatApiRef,
      deps: { discoveryApi: discoveryApiRef, fetchApi: fetchApiRef },
      factory: ({ discoveryApi, fetchApi }) =>
        new McpChat({ discoveryApi, fetchApi }),
    }),
});

/**
 * MCP Chat Page
 * @public
 */
const newMcpChatPage = PageBlueprint.make({
  params: {
    path: '/xpert',
    title: 'MCP Chat',
    icon: <BotIconComponent />,
    loader: () => import('./components/ChatPage').then(m => <m.NewChatPage />),
    routeRef: rootRouteRef,
  },
});

/**
 * MCP Chat plugin.
 @public
 */
const mcpChatPlugin = createFrontendPlugin({
  pluginId: 'mcp-chat',
  extensions: [mcpChatApi, newMcpChatPage],
  routes: {
    root: rootRouteRef,
  },
});

export default mcpChatPlugin;
